import { Directive, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TagAutocompleteComponent } from './tag-autocomplete.component';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, takeUntil } from 'rxjs/operators';
import { NgControl } from '@angular/forms';
import { TagAutocompleteService } from './tag-autocomplete-content.service';

@Directive({
  selector: '[tagAutocomplete]'
})
export class TagAutocompleteDirective implements OnInit {
  @Input() tagAutocomplete: [TagAutocompleteComponent,HTMLElement];
  private overlayRef: OverlayRef;
  private moreElem:HTMLElement;
  private destroy$:Subject<boolean> = new Subject();
  @Input() inputdisable:boolean = false;

  constructor(
    private host: ElementRef<HTMLInputElement>,
    private ngControl: NgControl,
    private viewContentRef: ViewContainerRef,
    private overlay: Overlay,
    private autocompleteservice:TagAutocompleteService
  ) {
  }

  get control() {
    return this.ngControl.control;
  }

  ngOnInit() {
    fromEvent(this.origin, 'focus').pipe(
    ).subscribe(() => {
      if((!this.overlayRef || !this.overlayRef.hasAttached()) && !this.inputdisable){
        this.ngControl.reset('')
        this.openDropdown();
      }
    });

    this.autocompleteservice.$moreclicked.pipe(takeUntil(this.destroy$)).subscribe((val)=>{
      if(!this.overlayRef || !this.overlayRef.hasAttached()){
        this.moreElem=val
        this.openDropdown();
      }
    })


  }

  openDropdown() {
    this.overlayRef = this.overlay.create({
      width: this.tagAutocomplete[1].offsetWidth+'px',
      maxHeight: 60 * 3,
      backdropClass: '',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      positionStrategy: this.getOverlayPosition()
    });

    const template = new TemplatePortal(this.tagAutocomplete[0].rootTemplate, this.viewContentRef);
    this.overlayRef.attach(template);
    overlayClickOutside(this.overlayRef, this.origin, this.moreElem).subscribe((val) => {
      this.close()
    });
  }

  private close() {
    this.overlayRef.detach();
  }

  private getOverlayPosition() {
    const positions = [
      new ConnectionPositionPair(
        { originX: 'start', originY: 'bottom' },
        { overlayX: 'start', overlayY: 'top' }
      ),
      new ConnectionPositionPair(
        { originX: 'start', originY: 'top' },
        { overlayX: 'start', overlayY: 'bottom' }
      )
    ];

    return this.overlay
      .position()
      .flexibleConnectedTo(this.tagAutocomplete[1])
      .withPositions(positions)
      .withFlexibleDimensions(false)
      .withPush(false);
  }

  get origin() {
    return this.host.nativeElement;
  }

  ngOnDestroy() {
    this.overlayRef?.detach()
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }
}

export function overlayClickOutside( overlayRef: OverlayRef, origin: HTMLElement,moreElem:HTMLElement) {
  return fromEvent<MouseEvent>(document, 'click')
    .pipe(
      filter(event => {

        const clickTarget = event.target as HTMLElement;
        const notOrigin = clickTarget !== origin; // the input
        const notmore =  clickTarget !== moreElem;
        const notOverlay = !!overlayRef && (overlayRef.overlayElement.contains(clickTarget) === false); // the autocomplete
        return notOrigin && notOverlay && notmore
      }),
      takeUntil(overlayRef.detachments())
    )
}
